"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pluralize = require("pluralize");
var _ = require("lodash");
var makeFieldName = function (name) {
    return _.lowerFirst(name);
};
var ignorePrefixNames = [
    "default",
    "system"
];
var processPrefix = function (prefix) {
    return prefix && ignorePrefixNames.some(function (value) { return value === prefix.toLowerCase(); }) ? "" : prefix;
};
var makeTypeName = function (prefix, name) {
    return "" + _.upperFirst(processPrefix(prefix)) + _.upperFirst(name);
};
var SchemaNameGenerator = {
    getTableTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, "" + pluralize.singular(tableName));
    },
    getTableItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName));
    },
    getTableListFieldName: function (tableName) {
        return makeFieldName(pluralize.plural(tableName) + "List");
    },
    getTableListResponseTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "ListResponse");
    },
    getTableManyResponseTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "ManyResponse");
    },
    getCreateItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "Create");
    },
    getCreateManyItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "CreateMany");
    },
    getUpdateItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "Update");
    },
    getUpdateByFilterItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "UpdateByFilter");
    },
    getDeleteItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "Delete");
    },
    getDeleteByFilterMutationName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "DeleteByFilter");
    },
    getDestroyItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "Destroy");
    },
    getDestroyByFilterMutationName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "DestroyByFilter");
    },
    getRestoreItemFieldName: function (tableName) {
        return makeFieldName(pluralize.singular(tableName) + "Restore");
    },
    getSmartTypeFieldName: function (fieldName) {
        return "Smart" + pluralize.singular(_.upperFirst(fieldName.toLowerCase()));
    },
    getSmartTypeFieldNamePredicate: function (fieldName) {
        return SchemaNameGenerator.getSmartTypeFieldName(fieldName) + "Predicate";
    },
    getSmartTypeSortInputTypeName: function (fieldName) {
        return SchemaNameGenerator.getSmartTypeFieldName(fieldName) + "Sort";
    },
    getSmartTypeGroupByInputTypeName: function (fieldName) {
        return SchemaNameGenerator.getSmartTypeFieldName(fieldName) + "GroupByQuery";
    },
    getOrderByInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "OrderBy");
    },
    getFilterInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "Filter");
    },
    getKeyFilterInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "KeyFilter");
    },
    getPermissionFilterInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "_PermissionFilter");
    },
    getFieldsPermissionsInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "FieldsPermissions");
    },
    getEnumItemTypeName: function (tableName, fieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "_" + _.upperFirst(fieldName) + "Enum");
    },
    getSortInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "Sort");
    },
    getGroupByInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "GroupBy");
    },
    getGroupByQueryInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "GroupByQuery");
    },
    getExtraFieldsInputTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "ExtraFields");
    },
    getUpdateInputName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "UpdateInput");
    },
    getUpdateByFilterInputName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "UpdateByFilterInput");
    },
    getDeleteInputName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "DeleteInput");
    },
    getCreateInputName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "CreateInput");
    },
    getCreateManyInputName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "CreateManyInput");
    },
    getRelationCreateInputName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, _.upperFirst(relationFieldName) + "_" + SchemaNameGenerator.getCreateInputName(tableName, typePrefix));
    },
    getRelationCreateManyInputName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, _.upperFirst(relationFieldName) + "_" + SchemaNameGenerator.getCreateManyInputName(tableName, typePrefix));
    },
    getRelationUpdateInputName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, _.upperFirst(relationFieldName) + "_" + SchemaNameGenerator.getUpdateInputName(tableName, typePrefix));
    },
    getRelationTableFilter: function (relationTableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(relationTableName) + "RelationFilter");
    },
    getRelationTablePermissionFilter: function (relationTableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(relationTableName) + "_PermissionRelationFilter");
    },
    getSubscriptionFilterName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "SubscriptionFilter");
    },
    getSubscriptionPayload: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "Payload");
    },
    getSmartInputType: function (fieldName) {
        return SchemaNameGenerator.getSmartTypeFieldName(fieldName) + "Input";
    },
    getSmartUpdateInputType: function (fieldName) {
        return SchemaNameGenerator.getSmartTypeFieldName(fieldName) + "UpdateInput";
    },
    getRelationName: function (tableName, relationFieldName, isUpdateField, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        var updateSuffix = (isUpdateField) ? "Update" : "";
        return "" + makeTypeName(typePrefix, tableName) + _.upperFirst(relationFieldName) + updateSuffix + "RelationInput";
    },
    getCreateRelationName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return "" + makeTypeName(typePrefix, tableName) + _.upperFirst(relationFieldName) + "RelationInput";
    },
    getCreateManyRelationName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return "" + makeTypeName(typePrefix, tableName) + _.upperFirst(relationFieldName) + "ManyRelationInput";
    },
    getUpdateRelationName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return "" + makeTypeName(typePrefix, tableName) + _.upperFirst(relationFieldName) + "UpdateRelationInput";
    },
    getUpdateByFilterRelationName: function (tableName, relationFieldName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return "" + makeTypeName(typePrefix, tableName) + _.upperFirst(relationFieldName) + "UpdateByFilterRelationInput";
    },
    getGroupResultTypeName: function (tableName, typePrefix) {
        if (typePrefix === void 0) { typePrefix = ""; }
        return makeTypeName(typePrefix, pluralize.singular(tableName) + "Group");
    },
};
exports.default = SchemaNameGenerator;
//# sourceMappingURL=SchemaNameGenerator.js.map